import React from 'react';
import { dmDevicesPath } from 'routing/paths';
// components
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CommonButton from 'components/Buttons/CommonButton';

interface Props {
  deviceId?: string;
}

export const DeviceNotFoundPage = ({ deviceId }: Props): JSX.Element => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      alignContent="space-between"
      justifyContent="center"
      height="80vh"
    >
      <Typography variant="h4">
        Device with ID: <b>{ deviceId ?? '0' }</b> not found
      </Typography>

      <CommonButton
        type="button"
        label="Back to list"
        LinkTo={ dmDevicesPath() }
        icon={ <ArrowBackIcon/> }
      />
    </Box>
  );
};